import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from "@angular/core";
import {Factor} from "../../model/factor";
import {QueryService} from "../../Services/query-service";

@Component({
  selector: 'gen-factor-viewer',
  templateUrl: './factor-viewer.component.html',
  styleUrls: ['./factor-viewer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FactorViewerComponent {

  @Input() factor: Factor;

  constructor(private queryService: QueryService) {
  }

  ngOnInit() {
  }

  // getFields(): string {
  //   let sep = this.factor.operator;
  //   sep = " <span class='operatorOr'>" + sep + "</span> ";
  //
  //   if (this.factor.biomarkers.length > 0) {
  //     return this.factor.biomarkers.map(x => this.biomarkerService.getRepresentation(x)).join(sep)
  //   } else if (this.factor.disorders.length > 0) {
  //     //return this.factor.disorders.map(x => x.disease).join(sep);
  //     return this.factor.disorders.map(x => this.disorderService.getRepresentation(x)).join(sep)
  //   } else {
  //     return "";
  //   }
  // }
}
